import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { urlConfig, getImageUrl } from '../../config';
import GiftImage, { getConditionBadgeClass } from '../common/GiftImage';
import '../common/GiftImage.css';
import './DetailsPage.css';

function DetailsPage() {
    const navigate = useNavigate();
    const { productId } = useParams();
    const [gift, setGift] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const authenticationToken = sessionStorage.getItem('auth-token');
        if (!authenticationToken) {
            navigate('/app/login');
            return;
        }

        const fetchGift = async () => {
            try {
                const response = await fetch(`${urlConfig.backendUrl}/api/gifts/${productId}`);
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();
                setGift(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchGift();
        window.scrollTo(0, 0);
    }, [productId, navigate]);

    const formatDate = (timestamp) => {
        return new Date(timestamp * 1000).toLocaleDateString('en-US', {
            weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'
        });
    };

    const comments = [
        { author: "John Doe", comment: "I would like this!", initials: "JD" },
        { author: "Jane Smith", comment: "Just DMed you.", initials: "JS" },
        { author: "Alice Johnson", comment: "I will take it if it's still available.", initials: "AJ" },
        { author: "Mike Brown", comment: "This is a good one!", initials: "MB" },
        { author: "Sarah Wilson", comment: "My family can use one. DM me if it is still available. Thank you!", initials: "SW" }
    ];

    if (loading) {
        return (
            <div className="page-container">
                <div className="loading-state">
                    <div className="loading-spinner" />
                    <p>Loading gift details...</p>
                </div>
            </div>
        );
    }

    if (error) return <div className="page-container"><div className="error-state">Error: {error}</div></div>;
    if (!gift) return <div className="page-container"><div className="empty-state">Gift not found</div></div>;

    return (
        <div className="page-container">
            <button className="back-link" onClick={() => navigate(-1)}>
                ← Back to listings
            </button>

            <div className="detail-layout">
                <div className="detail-panel">
                    <GiftImage
                        name={gift.name}
                        category={gift.category}
                        imageUrl={getImageUrl(gift.image)}
                        variant="detail"
                    />
                </div>

                <div className="detail-panel">
                    <div className="detail-panel__content">
                        <div className="gift-card__meta" style={{ marginBottom: '1rem' }}>
                            <span className={`badge-condition ${getConditionBadgeClass(gift.condition)}`}>
                                {gift.condition}
                            </span>
                            <span className="badge-category">{gift.category}</span>
                        </div>
                        <h1 className="detail-title">{gift.name}</h1>

                        <div className="detail-specs">
                            <div className="detail-spec">
                                <span className="detail-spec__label">Category</span>
                                <span className="detail-spec__value">{gift.category}</span>
                            </div>
                            <div className="detail-spec">
                                <span className="detail-spec__label">Condition</span>
                                <span className="detail-spec__value">{gift.condition}</span>
                            </div>
                            <div className="detail-spec">
                                <span className="detail-spec__label">Date Added</span>
                                <span className="detail-spec__value">{formatDate(gift.date_added)}</span>
                            </div>
                            <div className="detail-spec">
                                <span className="detail-spec__label">Age</span>
                                <span className="detail-spec__value">{gift.age_years} years</span>
                            </div>
                        </div>

                        <p className="detail-description-label">Description</p>
                        <p className="detail-description">{gift.description}</p>
                    </div>
                </div>
            </div>

            <section className="comments-panel">
                <h3>Comments</h3>
                {comments.map((comment, index) => (
                    <div key={index} className="comment-card">
                        <span className="comment-card__avatar">{comment.initials}</span>
                        <div className="comment-card__body">
                            <p className="comment-card__author">{comment.author}</p>
                            <p className="comment-card__text">{comment.comment}</p>
                        </div>
                    </div>
                ))}
            </section>
        </div>
    );
}

export default DetailsPage;
